// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  background: var(--ion-color-primary);
  height: 100%;
  overflow: auto;
}

ion-img {
  width: 50px;
}

.header_block {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header_block h3 {
  color: white;
  font-family: Tusker, sans-serif;
}

ul {
  list-style-type: none;
  padding: 0px;
  padding-bottom: 70px;
}

li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 20px;
  text-decoration: none;
}
li .wrapper {
  padding: 17px 20px;
  background: white;
  width: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
li .wrapper .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
li .wrapper .info_block p {
  padding: 0px 10px;
  color: var(--ion-color-primary);
  font-family: Tusker, sans-serif;
}
li .wrapper .info_block ion-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
}
li .wrapper .circle {
  width: 30px;
  height: 30px;
  content: " ";
  border: 2px solid var(--ion-color-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
li .wrapper .circle .cirle_inner {
  width: 22px;
  height: 22px;
  content: " ";
  background: transparent;
  border-radius: 50%;
}
li .wrapper .circle .cirle_inner.selected {
  background: var(--ion-color-tertiary);
  border-radius: 50;
  transition: ease-in-out 0.3s;
}

.line-border {
  padding: 0px 20px;
}
.line-border ion-icon {
  fill: white;
  width: 100%;
}

.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px;
  display: flex;
  justify-content: center;
}
.footer-item ion-button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-language-modal/select-language-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,oCAAA;EACA,YAAA;EACA,cAAA;AACJ;;AACA;EACI,WAAA;AAEJ;;AAAA;EACI,aAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AAEJ;AADI;EACI,YAAA;EACA,+BAAA;AAGR;;AAAA;EACI,qBAAA;EACA,YAAA;EACA,oBAAA;AAGJ;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AAGJ;AADI;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAGR;AAFQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;AAIZ;AAHY;EACI,iBAAA;EACA,+BAAA;EACA,+BAAA;AAKhB;AAHY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAKhB;AAFQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAIZ;AAFY;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAIhB;AAHgB;EACI,qCAAA;EACA,iBAAA;EACA,4BAAA;AAKpB;;AACA;EACI,iBAAA;AAEJ;AADI;EACI,WAAA;EACA,WAAA;AAGR;;AAAA;EACI,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAGJ;AAFI;EACI,WAAA;AAIR","sourcesContent":[".wrapper{\n    width: 100%;\n    background: var(--ion-color-primary);\n    height: 100%;\n    overflow: auto;\n}\nion-img {\n    width: 50px;\n}\n.header_block {\n    padding: 20px;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    h3 {\n        color: white;\n        font-family: Tusker, sans-serif;\n    }\n}\nul {\n    list-style-type: none;\n    padding: 0px;\n    padding-bottom: 70px;\n\n}\nli {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 20px;\n    text-decoration: none;\n  \n    .wrapper {\n        padding: 17px 20px;\n        background: white;\n        width: 100%;\n        border-radius: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        .info_block {\n            border-radius: 20px;\n            display: flex;\n            align-items: center;\n            p {\n                padding: 0px 10px;\n                color: var(--ion-color-primary);\n                font-family: Tusker, sans-serif;\n            }\n            ion-img {\n                width: 30px;\n                height: 30px;\n                border-radius: 50%;\n                overflow: hidden;\n            }\n        }\n        .circle {\n            width: 30px;\n            height: 30px;\n            content: ' ';\n            border: 2px solid var(--ion-color-primary);\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          \n            .cirle_inner {\n                width: 22px;\n                height: 22px;\n                content: ' ';\n                background: transparent;\n                border-radius: 50%;\n                &.selected {\n                    background: var(--ion-color-tertiary);\n                    border-radius: 50;\n                    transition: ease-in-out 0.3s;\n                }\n            }\n        }\n    }  \n}\n.line-border {\n    padding: 0px 20px;\n    ion-icon {\n        fill: white;\n        width: 100%;\n    }\n}\n.footer-item {\n    position: fixed;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    padding: 20px;\n    display: flex;\n    justify-content: center;\n    ion-button {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
